//full width swiper
$(document).ready(function() {
    const swiperFull = new Swiper ('#fullSwiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      mousewheel: false,
      spaceBetween: 30,
  
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      //pagination dots
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
});

//news & events swiper
$(document).ready(function() {
  const swiperNews = new Swiper ('#newsSwiper', {
    // Optional parameters
    loop: false,
    mousewheel: false,
    slidesPerView: 1,
    spaceBetween: 30,

    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.2,
        spaceBetween: 10,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    //pagination dots
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//news & events swiper
$(document).ready(function() {
  const swiperNews = new Swiper ('#customerStorySwiper', {
    // Optional parameters
    loop: false,
    mousewheel: false,
    slidesPerView: 'auto',
    spaceBetween: 30,

    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.2,
        spaceBetween: 10,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    //pagination dots
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//quote swiper
$(document).ready(function() {
  const swiperQuote = new Swiper ('#quoteSwiper', {
    // Optional parameters
    direction: 'horizontal',
    autoHeight: true, //enable auto height
    loop: false,
    mousewheel: false,
    spaceBetween: 35,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
     //pagination dots
     pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
